import { Controller } from '@hotwired/stimulus'
import { hasCookie, writeFlagCookie } from 'javascripts/common/cookie'

// 「閉じた」事実をセッション Cookie に記録する。描画可否の判定はサーバー側が Cookie を見て行う。
// message-panel:close イベントを受けて記録する（例: data-action="message-panel:close->dismissal-cookie#remember"）。
export default class extends Controller {
  static values = { key: String }

  connect() {
    // Turbo のキャッシュプレビューは閉じる前のDOMを復元するため、記録済みなら取り除く
    if (hasCookie(this.keyValue)) this.element.remove()
  }

  remember() {
    writeFlagCookie(this.keyValue)
  }
}
